import { render } from "./CadastroVeiculoTrator.vue?vue&type=template&id=9e0a4102&scoped=true"
import script from "./CadastroVeiculoTrator.vue?vue&type=script&lang=ts"
export * from "./CadastroVeiculoTrator.vue?vue&type=script&lang=ts"

import "./CadastroVeiculoTrator.vue?vue&type=style&index=0&id=9e0a4102&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-9e0a4102"

export default script